import { useEffect, useRef, useState } from "react";
import useAuth from "src/hooks/useAuth";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import ThemeSettings from "src/components/ThemeSettings";
import {
  Avatar,
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography,
  styled,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import InboxTwoToneIcon from "@mui/icons-material/InboxTwoTone";
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
import AccountBoxTwoToneIcon from "@mui/icons-material/AccountBoxTwoTone";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import AccountTreeTwoToneIcon from "@mui/icons-material/AccountTreeTwoTone";
import React from "react";
import { Client } from "../../../DashboardApi/api";
import {
  REACT_APP_PORTAL_API_URL,
  REACT_APP_LOGIN_PAGE,
} from "../../../../KeyVariables";
import { jwtDecode } from "jwt-decode";

export const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(0)};
        color: ${theme.colors.alpha.trueWhite[70]};

        &:hover {
          color: ${theme.colors.alpha.trueWhite[100]};
        }
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

export const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

export const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

export const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${theme.palette.secondary.light}
`
);

interface HeaderUserboxProps {
  currentUser: any;
}
export const isUserAd = (token) => {
  try {
    const decoded = jwtDecode<ICustomClaims>(token);
    if (decoded.isAd != undefined) {
      if (decoded.isAd && decoded.isAd == true) {
        return true;
      } else {
        return false;
      }
      return false;
    }
    return false;
  } catch (error) {
    console.error("Invalid token:", error);
    return false;
  }
};

export interface ICustomClaims {
  isAd: boolean;
}
function HeaderUserbox({ currentUser }: HeaderUserboxProps) {
  const { t }: { t: any } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const apiUrl = REACT_APP_PORTAL_API_URL;
  const client = new Client(apiUrl);
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

const handleLogout = async (): Promise<void> => {
  try {
    const token = localStorage.getItem("accessToken");
    localStorage.clear();

    window.location.href = `${REACT_APP_LOGIN_PAGE}?logout=true`;
  } catch (err) {
    console.error(err);
    window.location.href = `${REACT_APP_LOGIN_PAGE}?logout=true`;
  }
};

  return (
    <Box
      component="span"
      sx={{
        display: { xs: "inline-block", sm: "inline-block" },
      }}
    >
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar />
        <ExpandMoreTwoToneIcon
          fontSize="small"
          sx={{
            ml: 0.5,
          }}
        />
      </UserBoxButton>
      <Popover
        disableScrollLock
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuUserBox
          sx={{
            minWidth: 210,
          }}
          display="flex"
        >
          <Avatar variant="rounded" alt={currentUser?.firstName} />
          <UserBoxText>
            <UserBoxLabel variant="body1">
              {currentUser?.firstName} {currentUser?.lastName}
            </UserBoxLabel>
            <UserBoxDescription variant="body2">
              {currentUser?.role}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider
          sx={{
            mb: 0,
          }}
        />
        <List
          sx={{
            p: 1,
          }}
          component="nav"
        >
          {/* <ListItem
            button
            onClick={() => {
              handleClose();
            }}
            to={`/${
              location.pathname.split("/")[1]
            }/applications/mailbox/inbox`}
            component={NavLink}
          >
            <InboxTwoToneIcon fontSize="small" />
            <ListItemText primary={t("Tasks")} />
          </ListItem> */}
          {/* <ListItem
            button
            onClick={() => {
              handleClose();
            }}
            to={`/${
              location.pathname.split("/")[1]
            }/applications/projects-board`}
            component={NavLink}
          >
            <AccountTreeTwoToneIcon fontSize="small" />
            <ListItemText primary={t("Projects")} />
          </ListItem> */}
        </List>
        <Divider />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Box m={1}>
            <Button color="primary" onClick={handleLogout}>
              <LockOpenTwoToneIcon sx={{ mr: 1 }} />
              {t("Sign out")}
            </Button>
          </Box>
          <Box m={1}>
            <ThemeSettings />
          </Box>
        </div>
      </Popover>
    </Box>
  );
}

export default HeaderUserbox;
